module.exports = __webpack_public_path__ + "static/logo-94f95d3b8ee2af79d50d1d0c656ab70f.png";